/**
 * @desc Checks if `value` is `undefined`.
 * @category Lang
 *
 * @param  {*} x value
 * @return {boolean} isUndefined
 *
 * @since 4.0.0-alpha.1
 * @memberOf is
 * @func isUndefined
 *
 * @see is/nullOrUndefined
 * @see https://github.com/infernojs/inferno/blob/master/packages/inferno-shared/src/index.ts#L57
 *
 * @NOTE || typeof x === 'undefined'
 *
 * @example
 *
 *  isUndefined(undefined)
 *  //=> true
 *  isUndefined(void 0)
 *  //=> true
 *
 *  isUndefined(null)
 *  //=> false
 *  isUndefined(NaN)
 *  //=> false
 *  isUndefined({})
 *  //=> false
 *  isUndefined('')
 *  //=> false
 *  isUndefined(1)
 *  //=> false
 *  isUndefined(false)
 *  //=> false
 *
 */
module.exports = function (x) { return x === undefined; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5kZWZpbmVkLmpzIiwic291cmNlcyI6WyJ1bmRlZmluZWQuanMiXSwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBAZGVzYyBDaGVja3MgaWYgYHZhbHVlYCBpcyBgdW5kZWZpbmVkYC5cbiAqIEBjYXRlZ29yeSBMYW5nXG4gKlxuICogQHBhcmFtICB7Kn0geCB2YWx1ZVxuICogQHJldHVybiB7Ym9vbGVhbn0gaXNVbmRlZmluZWRcbiAqXG4gKiBAc2luY2UgNC4wLjAtYWxwaGEuMVxuICogQG1lbWJlck9mIGlzXG4gKiBAZnVuYyBpc1VuZGVmaW5lZFxuICpcbiAqIEBzZWUgaXMvbnVsbE9yVW5kZWZpbmVkXG4gKiBAc2VlIGh0dHBzOi8vZ2l0aHViLmNvbS9pbmZlcm5vanMvaW5mZXJuby9ibG9iL21hc3Rlci9wYWNrYWdlcy9pbmZlcm5vLXNoYXJlZC9zcmMvaW5kZXgudHMjTDU3XG4gKlxuICogQE5PVEUgfHwgdHlwZW9mIHggPT09ICd1bmRlZmluZWQnXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiAgaXNVbmRlZmluZWQodW5kZWZpbmVkKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzVW5kZWZpbmVkKHZvaWQgMClcbiAqICAvLz0+IHRydWVcbiAqXG4gKiAgaXNVbmRlZmluZWQobnVsbClcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNVbmRlZmluZWQoTmFOKVxuICogIC8vPT4gZmFsc2VcbiAqICBpc1VuZGVmaW5lZCh7fSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNVbmRlZmluZWQoJycpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzVW5kZWZpbmVkKDEpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzVW5kZWZpbmVkKGZhbHNlKVxuICogIC8vPT4gZmFsc2VcbiAqXG4gKi9cbm1vZHVsZS5leHBvcnRzID0geCA9PiB4ID09PSB1bmRlZmluZWRcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQXFDQSxNQUFNLENBQUMsT0FBTyxHQUFHLFVBQUEsQ0FBQyxDQUFBLENBQUMsQUFBRyxTQUFBLENBQUMsS0FBSyxTQUFTLEdBQUE7In0=